var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "card group-wrapper p-4 my-4" },
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _vm.$slots["title"]
            ? _c("section-title", [_vm._t("title")], 2)
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }